export const environment = {
    production: false,
    tag: "UAT",
    environmentBanner: "Test Environment",

    authServerBasePath: "https://portalserver-uat.acimobills.com/auth/api",
    portalServerBasePath: "https://portalserver-uat.acimobills.com/portal/api",    

    portalBasicAuth: "Basic dXNyX21vbml0b3I6TUdsM21JM1dJaVpXVTdFWQ==",

    disbursementsBasePath: '/disbursements/api',
    walletronBasePath: '/walletron/api',
    walletronRegions: [
        {region: "uat", baseUrl: "https://uat.walletron.click"}
    ],
    
    passwordResetUrl: 'https://walletron-agent-uat.acimobills.com/auth/psw-reset'   

};